const initialState = {
    data: {
        memberId:'N-N',
        balanceIn: 'N-N',
        balanceInToken: 'N-N',
        proposalsNum: 'N-N',
        recipient:'N-N',
        amount:'N-N',
        description:'N-N',
        voteYes:'N-N',
        voteNo:'N-N',
        allVotes:'N-N',
        minimumVotes:'N-N',
        enoughBudget:false,
        isExecuted:false,
        isDeadlineOver:false,
        deadline:'N-N',
        proposalId:'N-N',
        isVoted:false
    }
} 

const proposalReducer = (state = initialState, action) => {
    if (action.type === 'SET_PROPOSAL'){
        return Object.assign({}, state, {
            data: action.payload
        })
    }

    if (action.type === 'PROPOSAL_LOGGED_OUT'){
        return Object.assign({}, state, {
            data: {
                memberId:'N-N',
                balanceIn: 'N-N',
                balanceInToken: 'N-N',
                proposalsNum: 'N-N',
                recipient:'N-N',
                amount:'N-N',
                description:'N-N',
                enoughBudget:false,
                voteYes:'N-N',
                voteNo:'N-N',
                allVotes:'N-N',
                minimumVotes:'N-N',
                isExecuted:false,
                isDeadlineOver:false,
                deadline:'N-N',
                proposalId:'N-N',
                isVoted:false
            }
        })
    }
  
    return state
}

export default proposalReducer


// WEBPACK FOOTER //
// ./src/user/proposalReducer.js